





import Vue from "vue";
import { ApplicationActions } from "../store";
import { Dispatcher, Committer } from "vuex-type-helper";

export default Vue.extend({
  mounted() {
    this.$store.dispatch<Dispatcher<ApplicationActions>>({
      type: "setJWT",
      jwt: ""
    });

    this.$router.push({ name: "login" });
  }
});
